import { useEffect, useMemo, useState } from 'react';
import * as S from './styles';
import SubMissionTab from '../../SubMissionTab';
import DailyMission from './DailyMission';
import CheckInMission from './CheckInMission';
import {
  CategoryType,
  Mission,
  useTradeMission,
} from '@/app/hooks/trade/tradeMission';
import { getMissionTemplateCode, MissionCode } from '../../utils';
import RewardLoading from '../RewardLoading';
import { useTranslation } from 'react-i18next';

export enum SubMission {
  DAILY = 'daily',
  CHECK_IN = 'check-in',
}

const subMissions = [SubMission.DAILY, SubMission.CHECK_IN];

const RewardDaily = () => {
  const { t } = useTranslation();
  const [currentSubMission, setCurrentSubMission] = useState<SubMission>(
    SubMission.DAILY
  );
  const [checkInDetailMission, setCheckInDetailMission] =
    useState<Mission | null>(null);
  const [detailDailyMission, setDetailDailyMission] = useState<Mission[]>([]);

  const {
    data,
    getMissionDetail,
    getMissionReward,
    checkInMission,
    isLoading,
  } = useTradeMission(CategoryType.DAILY); // 카테고리별 API 호출

  const dailyMissions = useMemo(
    () =>
      (data?.missions ?? []).filter(
        (mission) =>
          getMissionTemplateCode(mission.code) ===
          MissionCode.DAILY_ACTIVITY_GOAL
      ),
    [data?.missions]
  );

  useEffect(() => {
    if (dailyMissions.length === 0) {
      setDetailDailyMission([]);
      return;
    }

    Promise.all(
      dailyMissions.map((mission) => getMissionDetail(mission.id))
    ).then((missions) => {
      setDetailDailyMission(missions);
    });
  }, [dailyMissions]);

  const checkInMissions = (data?.missions ?? []).find(
    (mission) =>
      getMissionTemplateCode(mission.code) === MissionCode.ATTENDANCE_STREAK
  );

  useEffect(() => {
    if (checkInMissions?.id) {
      getMissionDetail(checkInMissions.id).then((res) => {
        setCheckInDetailMission(res);
      });
    } else {
      setCheckInDetailMission(null);
    }
  }, [checkInMissions, getMissionDetail]);

  if (isLoading || !detailDailyMission.length || !checkInDetailMission) {
    return <RewardLoading messageKey="loadingDailyMission" />;
  }

  return (
    <S.Container>
      <SubMissionTab
        currentSubMission={currentSubMission}
        setCurrentSubMission={setCurrentSubMission}
        subMissions={subMissions}
      />

      {currentSubMission === SubMission.DAILY && (
        <DailyMission
          detailDailyMission={detailDailyMission}
          getMissionReward={getMissionReward}
        />
      )}
      {currentSubMission === SubMission.CHECK_IN && (
        <CheckInMission
          checkInDetailMission={checkInDetailMission}
          checkInMission={checkInMission}
          getMissionReward={getMissionReward}
        />
      )}
    </S.Container>
  );
};

export default RewardDaily;
